import { render, staticRenderFns } from "./VatId.vue?vue&type=template&id=d76e2510&"
import script from "./VatId.vue?vue&type=script&lang=js&"
export * from "./VatId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../plentyDevTool/38547/54/d2gPmPluginReturnsEGP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/patrickbittner/plentyDevTool/38547/54/d2gPmPluginReturnsEGP/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d76e2510')) {
      api.createRecord('d76e2510', component.options)
    } else {
      api.reload('d76e2510', component.options)
    }
    module.hot.accept("./VatId.vue?vue&type=template&id=d76e2510&", function () {
      api.rerender('d76e2510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plentymarkets/5.0.31/plugin-ceres/resources/js/src/app/components/customer/VatId.vue"
export default component.exports